import script from "./AddService.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddService.vue?vue&type=script&setup=true&lang=ts"

import "./AddService.vue?vue&type=style&index=0&id=69daf1bf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69daf1bf"]])

export default __exports__